<template>
    <fieldset>
        <legend ref="legend" tabindex="0" class="question">{{ question.text }}</legend>
        <slot name="answers">
            <ul class="no-bullet radio-list" role="radiogroup" :aria-describedby="`errorQ${currentQuestion + 1}`">
                <li v-for="(answer, i) in question.answers" :key="i">
                    <div class="radio-wrapper">
                        <Field
                            :id="`input-radio-${i}`"
                            v-model="checkRadio"
                            rules="required"
                            type="radio"
                            :value="answer.id"
                            :name="`question${currentQuestion + 1}`"
                        />
                        <label :for="`input-radio-${i}`">
                            {{ answer.text }}
                        </label>
                    </div>
                    <TextInput
                        v-if="answer.dynamicField && results[3] && results[3].id === 3"
                        :id="`nbRides${question.id}`"
                        v-model="question.answers[i].nbRides"
                        rules="required|integer|min_value:1"
                        :label="label"
                        name="nbRides"
                        :error="dynamicErrorMsg"
                        :maxlength="2"
                        size="small"
                        type="number"
                        min-value="1"
                        max-value="99"
                    />
                </li>
            </ul>
            <p v-show="displayError" :id="`errorQ${currentQuestion + 1}`" class="form-error" aria-live="assertive">
                {{ displayError }}
            </p>
        </slot>
    </fieldset>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { Field, useField } from 'vee-validate';

import TextInput from '@/best-fare/components/TextInput';

const props = defineProps({
    modelValue: {
        type: Number,
        default: 0,
    },
    currentQuestion: {
        type: Number,
        default: 0,
    },
    dynamicErrorMsg: {
        type: String,
        default: '',
        required: false,
    },
    errorMsg: {
        type: String,
        default: '',
        required: false,
    },
    label: {
        type: String,
        default: '',
        required: false,
    },
    question: {
        type: Object,
        default() {
            return {};
        },
    },
    results: {
        type: Array,
        default() {
            return [];
        },
    },
})

const emit = defineEmits(['update:modelValue']);

const legend = ref(null);

const { errorMessage } = useField(
    () => `question${props.currentQuestion + 1}`,
    'required',
    {
        syncVModel: true,
    }
);

const checkRadio = computed({
    get() {
        return props.modelValue;
    },
    set(value) {
        emit('update:modelValue', parseInt(value));
    },
});

const displayError = computed(() => {
    return props.errorMsg || errorMessage.value || '';
});

onMounted(() => {
    if (props.currentQuestion !== 0 && legend.value) {
        legend.value.focus();
    }
});
</script>

<style lang="scss" scoped>
.question {
    @include rem-typo(18px);
    font-weight: 800;
    margin-bottom: 16px;
    @include breakpoint(medium) {
        @include rem-typo(20px);
        margin-bottom: 24px;
    }
}
fieldset {
    margin-bottom: 16px;
}
.radio-list {
    margin-bottom: 0;
}
</style>
